import { render } from 'preact';
import './styles.css';

const root = document.getElementById('app')!;
if (/^\/admin(?:\/|$)/.test(window.location.pathname)) {
  void import('./admin/AdminApp').then(({ AdminApp }) => render(<AdminApp />, root));
} else {
  void import('./App').then(({ App }) => render(<App />, root));
}
